import React from "react";
import styled from "styled-components";
import contactBg from "../../../assets//images/contact-bg.png";
import circle from "../../../assets//images/circle.png";
import { StaticImage } from "gatsby-plugin-image";

import { Swiper, SwiperSlide } from "swiper/react";

import items from "../../../constants/index/contact";

const Contact = () => {
  return (
    <Wrapper>
      <div className="container-lg">
        <div className="row">
          <div className="col-md-12">
            <h1 className="text-center">Tu tranquilidad a un click</h1>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-sm-12  col-lg-6 text-center">
            <StaticImage
              src="../../../assets/images/laptop.png"
              alt="tranquilidad"
              className="img-fluid"
              placeholder="tracedSVG"
            />
          </div>
          <div className="col-sm-12 col-lg-6">
            <Swiper spaceBetween={0} navigation className="contact-swiper">
              {items.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div className="slide">
                      <div className="media">
                        <h3>{item.id}</h3>
                        <div className="media-body">
                          <h5 className="mt-0">{item.title}</h5>
                          <p>{item.text}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
        <div className="row align-items-end contact-info mt-5 d-none d-lg-flex">
          <div className="col-sm-6 col-md-4 col-lg-6 text-center ">
            <h2>
              Comienza a vivir <br className="d-none d-md-block" /> CON
              TRANQUILIDAD.
            </h2>
            <p>
              Desde este momento vive la experiencia bajatuseguro y deja que
              nuestros gurús en tranquilidad te guien en todo momento.
            </p>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-6 text-center text-md-right mt-4 mt-md-0">
            <a href="#" className="btn btn-warning">
              Contáctanos
            </a>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Contact;

export const Wrapper = styled.section`
  padding: 40px 0;
  position: relative;

  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media (min-width: 992px) {
    background-image: url(${contactBg});
  }
  &:before {
    content: "";
    background-image: url(${circle});
    height: 153px;
    width: 100%;
    top: 27px;
    right: 140px;
    position: absolute;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .contact-swiper {
    background: radial-gradient(#fff, #3cdbc0);
    /* background: transparent linear-gradient(180deg, #ffffff00 0%, #3cdbc0 100%)
      0% 0% no-repeat padding-box;
    opacity: 1; */
    margin-top: 2rem;

    @media (min-width: 992px) {
      background: none;
      margin-top: 0;
    }
  }
  .slide {
    padding: 1rem 2.5rem;
    width: 90%;
    margin: auto;
  }

  h1 {
    color: #3cdbc0;
    font-size: 45px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .media {
    h3 {
      color: #5268c2;
      opacity: 45%;
      font-size: 100px;
      font-weight: 900;
      margin-right: 10px;
      margin-top: -10px;
      line-height: 75px;
    }

    h5 {
      color: #5268c2;
      font-weight: 700;
      font-size: 22px;
    }

    p {
      color: #8e8e8e;
      margin-bottom: 0;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: #fff !important;
    @media (min-width: 992px) {
      color: #3cdbc0 !important;
    }
  }
`;
